import 'video.js';
// import 'videojs-hotkeys';
import 'dashjs';
import 'videojs-contrib-dash';
import 'videojs-contrib-eme';
import 'videojs-contrib-ads';
import 'videojs-ima';
import VimmiPlayer from './js/vimmiPlayer';
import Tools from './js/services/tools';

new VimmiPlayer('vimmi_video_player', Tools.parseQueryOptions(location.search));

